import React, { Component } from 'react'
import './EquipeList.scss'

import Isvg from 'react-inlinesvg'
import iconTwitter from '../../sass/icons/icon-twitter.svg'
import iconLinkedIn from '../../sass/icons/icon-linkedin.svg'

class EquipeList extends Component {
  render() {
    return (
      <section className="equipe-section">
        <div className="container featured-image-container">
          <div className="grid">
            <div className="col">
              <img className="featured-image" src={require('../../sass/images/equipe.jpg')} alt=""/>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="grid-2-spaceAround profiles">
            <div className="col-5_xs-12 profile">

              <img src={require("../../sass/images/equipe/equipe-eden-avatar@2x.png")} alt=""/>

              <h6>Eden Wiedemann <small>CEO</small></h6>

              <div className="social-links grid-center">
                <a href="https://twitter.com" className="twitter">
                  <Isvg src={iconTwitter} />
                </a>
                <a href="https://linkedin.com" className="linkedin">
                  <Isvg src={iconLinkedIn} />
                </a>
              </div>

              <div className="description">
                <p>Nunca é demais lembrar o peso e o significado destes problemas, uma vez que a expansão dos mercados mundiais oferece uma interessante oportunidade para verificação das direções preferenciais no sentido do progresso.</p>
              </div>
            </div>
            <div className="col-5_xs-12 profile">

              <img src={require("../../sass/images/equipe/equipe-gus-avatar@2x.png")} alt=""/>

              <h6>Gus Fune <small>CTO</small></h6>

              <div className="social-links grid-center">
                <a href="https://twitter.com" className="twitter">
                  <Isvg src={iconTwitter} />
                </a>
                <a href="https://linkedin.com" className="linkedin">
                  <Isvg src={iconLinkedIn} />
                </a>
              </div>

              <div className="description">
                <p>Nunca é demais lembrar o peso e o significado destes problemas, uma vez que a expansão dos mercados mundiais oferece uma interessante oportunidade para verificação das direções preferenciais no sentido do progresso.</p>
              </div>
            </div>
            <div className="col-5_xs-12 profile">

              <img src={require("../../sass/images/equipe/equipe-jackson-avatar@2x.png")} alt=""/>

              <h6>Jackson Fullen <small>CBO</small></h6>

              <div className="social-links grid-center">
                <a href="https://twitter.com" className="twitter">
                  <Isvg src={iconTwitter} />
                </a>
                <a href="https://linkedin.com" className="linkedin">
                  <Isvg src={iconLinkedIn} />
                </a>
              </div>

              <div className="description">
                <p>Nunca é demais lembrar o peso e o significado destes problemas, uma vez que a expansão dos mercados mundiais oferece uma interessante oportunidade para verificação das direções preferenciais no sentido do progresso.</p>
              </div>
            </div>
            <div className="col-5_xs-12 profile">

              <img src={require("../../sass/images/equipe/equipe-alexandre-avatar@2x.png")} alt=""/>

              <h6>Alexandre Saullouti <small>CBO</small></h6>

              <div className="social-links grid-center">
                <a href="https://twitter.com" className="twitter">
                  <Isvg src={iconTwitter} />
                </a>
                <a href="https://linkedin.com" className="linkedin">
                  <Isvg src={iconLinkedIn} />
                </a>
              </div>

              <div className="description">
                <p>Nunca é demais lembrar o peso e o significado destes problemas, uma vez que a expansão dos mercados mundiais oferece uma interessante oportunidade para verificação das direções preferenciais no sentido do progresso.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default EquipeList;



// WEBPACK FOOTER //
// ./src/components/EquipeList/index.js